export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const WIDGET_SEARCH_HISTORY_ADD = "WIDGET_SEARCH_HISTORY_ADD";
export const WIDGET_SEARCH_HISTORY_UPDATE = "WIDGET_SEARCH_HISTORY_UPDATE";

export const WIDGET_CALLS_ADD = "WIDGET_CALLS_ADD";
export const WIDGET_MANAGER_PHONE_UPDATE = "WIDGET_MANAGER_PHONE_UPDATE";
